import { Output } from '@angular/core';
import { Component, Inject, OnInit, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-notes-edit',
  templateUrl: './notes-edit.component.html',
  styleUrls: ['./notes-edit.component.scss']
})
export class NotesEditComponent implements OnInit {
  public quillModules = {
    toolbar: [['bold', 'italic', 'underline'],
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    ['clean']
    ]    
  }
  @Output() edit = new EventEmitter<boolean>();

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<NotesEditComponent>,    
    @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

  ngOnInit(): void {

        // wire up the logos - this will get loaded by the main page
        // so aren't doing for every entity
       

        // sort out the order stuff         
        // remember the original values
      
  }
save(){
  this.dialogRef.close(this.data);
}
close(){
  this.dialogRef.close("cancel");
}
editorInit(quill: any){
  quill.clipboard.addMatcher(Node.ELEMENT_NODE, function(node, delta){
    delta.forEach(e => {
      // remove any funny no length spaces
      if(e["insert"] && typeof e["insert"] == "string"){
        e["insert"] = e["insert"].replace(/[\u200B-\u200D\uFEFF]/g,'')
      }
      
      // remove any color properties
      if(e.attributes){
        e.attributes.color = '';
        e.attributes.background = '';
      }
    });
    return delta;
  });
}
}